import styled from 'styled-components';
const PromptText = styled.div `
  margin: 0 0 15px 0;
  font-size: ${props => props.theme.fontSizes.promptText};
  max-width: 310px;
`;
const ControlWrapper = styled.div `
  width: 275px;  
  margin: 10px 0 0 0;
`;
export { ControlWrapper, PromptText };
